export function eventDate(d = new Date()) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return {
    date: d.toISOString(),
    month: months[d.getMonth()],
    day: d.getDate(),
    year: d.getFullYear(),
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-event/utils.js